import Axios from 'axios';
import { UrlUtils } from '@garmin/support-utils';

// eslint-disable-next-line import/prefer-default-export
export const capi = Axios.create({
  baseURL: `${UrlUtils.getBaseUrl()}/exchange/capi`,
  headers: {
    'x-csrf-token': window?.AppData?.csrf,
  },
});
